<template>
  <div id="complete-step">
    <center><font-awesome-icon class="icon" :icon="faCheckCircle" /></center>
    <center><div class='info'>{{ $t('COMPLETE') }} {{ $t('REDEEM') }}</div></center>
    <center><primary-button @click="complete" class="button" rounded-corner :text="$t('BACK')" /></center>
  </div>
</template>

<script>
import PrimaryButton from '@/components/PrimaryButton';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'CompleteStep',
  components: {
    PrimaryButton,
    FontAwesomeIcon,
  },
  setup(_, { root }) {
    const contractMifosId = Number.parseInt(root.$route.params.id, 0);

    const complete = () => root.$router.push({ name: 'contract-detail', params: { id: contractMifosId } });
    return {
      complete,
      faCheckCircle,
    };
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#complete-step {
  background-color: $white;
  border-radius: 8px;
  border: 1px solid $doveGray;
  padding: 44px 0px;

  .icon {
    font-size: 120px;
    color: $aoEnglish;
  }

  .info {
    font-size: 70px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bolder;
    color: $independence;
  }

  .button {
    margin-top: 50px;
  }
}
</style>
